import React from 'react';
import { Head } from 'react-static';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { H2, H3, P } from '../components/typo';
import { Address, PaddingWrap, DescriptionWrap } from '../components/layout';
import legal from '../content/legal';
import NextProject from '../components/NextProject';
import { ModalConsumer } from '../components/ModalProvider';
import { widthBp, sizes } from '../lib/styles';

const Column = styled(P)`
  column-count: 1;
  @media (${widthBp(sizes.handheld)}) {
    column-count: 2;
  }
  cite {
    display: inline-block;
    font-size: 15px;
    margin-top: 3px;
  }
`;

const Legal = () => {
  const { t } = useTranslation();
  return (
    <ModalConsumer>
      {({ isMenuOpen }) => (
        <PaddingWrap isMenuOpen={isMenuOpen}>
          <Head title="Fabian Schroder - Legal" />
          <DescriptionWrap>
            <H2>{t('legal.title')}</H2>
          </DescriptionWrap>
          <Address>
            <P>
              <a
                href={`mailto:${t('legal.mail')}`}
                tabIndex={isMenuOpen ? '-1' : '0'}
                rel="noopener noreferrer"
              >
                {t('legal.mail')}
              </a>
              <br />
              {t('legal.tel')}
            </P>
          </Address>
          <DescriptionWrap>
            <H3>{t('legal.copyrightTitle')}</H3>
            {<Column dangerouslySetInnerHTML={{ __html: t('legal.copyright') }} />}
          </DescriptionWrap>
          <DescriptionWrap>
            <H3>{t('legal.dataProtectionTitle')}</H3>
            {<Column dangerouslySetInnerHTML={{ __html: t('legal.tracking') }} />}
          </DescriptionWrap>
          <DescriptionWrap>
            <H3>{t('legal.liabilityLinksTitle')}</H3>
            {<Column dangerouslySetInnerHTML={{ __html: t('legal.liabilityLinks') }} />}
          </DescriptionWrap>

          <DescriptionWrap noMargin>
            <H3>{t('legal.design')}</H3>
            {<Column dangerouslySetInnerHTML={{ __html: t('legal.myself') }} />}
          </DescriptionWrap>

          <NextProject
            to={legal.nextPath}
            label={t('generic.back')}
          />
        </PaddingWrap>
      )}
    </ModalConsumer>
  );
};

export default Legal;
